import { useOutOfOfficeHours } from '../../../working-hours/hooks/useOutOfOfficeHours';
import { useCurrentUserCapacityLimits } from '../../hooks/useUserLevelCapacityLimits';
import { CapacityStatus } from './CapacityStatus';
import { OutOfOfficeLabel } from './OutOfOfficeLabel';
import { jsx as _jsx } from "react/jsx-runtime";
export const StatusMessage = ({
  agentId,
  awayMode
}) => {
  const {
    currentSegment,
    isLoadingOOOHours
  } = useOutOfOfficeHours(agentId, {
    isViewingSelf: true
  });
  const {
    capacity,
    loading: isLoadingCapacity
  } = useCurrentUserCapacityLimits();
  if (isLoadingOOOHours || isLoadingCapacity) {
    return null;
  }
  if (currentSegment) {
    return /*#__PURE__*/_jsx(OutOfOfficeLabel, {
      userId: agentId,
      currentSegment: currentSegment
    });
  } else if (capacity && !awayMode) {
    return /*#__PURE__*/_jsx(CapacityStatus, {
      userCapacity: capacity
    });
  } else {
    return null;
  }
};
StatusMessage.displayName = 'StatusMessage';